import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { ModalContainerComponent } from '../../../../../../components/modals/modal-container.component';
import { IModal } from '../../../../../../components/modals/modal.interface';
import { ManualAuditIssueService } from '../../../../../../services/manual-audit-issue.service';
import {
  $auditFinding,
  AuditFindingQAStatus,
  AuditFindingQAStatusDisplayLabel,
} from '../../../../../../../../shared/constants/audit-finding';
import { CommonUtility } from '../../../../../../utility/common.utility';
import {
  IManualFindingBulkStatusChangeRequest,
  IPopulatedManualFinding,
} from '../../../../../../../../shared/interfaces/manual-audit-finding.interface';

@Component({
  selector: 'app-bulk-change-status-modal',
  templateUrl: './bulk-change-status-modal.component.html',
  standalone: false,
})
export class BulkChangeStatusModalComponent implements OnDestroy, IModal {
  private subscription: Subscription = new Subscription();

  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  public targetStatusOptions: AuditFindingQAStatus[] = [
    AuditFindingQAStatus.open,
    AuditFindingQAStatus.fixed,
    AuditFindingQAStatus.partiallyFixed,
    AuditFindingQAStatus.notFixed,
    AuditFindingQAStatus.notReproducible,
    AuditFindingQAStatus.cannotBeFixed,
  ];
  public AuditFindingQAStatusDisplayLabel: typeof AuditFindingQAStatusDisplayLabel = AuditFindingQAStatusDisplayLabel;
  public selectId: string = CommonUtility.createUniqueDOMId('target-status-select');
  public targetStatus: Exclude<AuditFindingQAStatus, AuditFindingQAStatus.dismissed> = null;

  @Input()
  public findings: IPopulatedManualFinding[] = [];
  @Input()
  public metadata: { workspaceId: string; digitalPropertyId: string; scanId: string };
  @Output()
  public statusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private manualAuditIssueService: ManualAuditIssueService) {}

  public changeStatus(): void {
    const findingIds: string[] = this.findings
      .filter((finding: IPopulatedManualFinding) => finding[$auditFinding.QAStatus] !== this.targetStatus)
      .map((finding: IPopulatedManualFinding) => finding[$auditFinding.issueId]);

    const done = (statusChanged: boolean): void => {
      this.statusChange.emit(statusChanged);
      this.container.closeModal();
    };

    if (findingIds.length > 0) {
      const changeRequest: IManualFindingBulkStatusChangeRequest = {
        manualAuditIssueIds: findingIds,
        issueStatus: this.targetStatus,
      };

      this.subscription.add(
        this.manualAuditIssueService
          .bulkUpdateFindingStatuses(
            this.metadata.workspaceId,
            this.metadata.digitalPropertyId,
            this.metadata.scanId,
            changeRequest,
          )
          .subscribe(() => done(true)),
      );
    } else {
      done(false);
    }
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
